
import * as pdfjs from 'pdfjs-dist/build/pdf';


 export const PdfjsBuild =`https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`

 